import { DraftHistoryViewModel } from "./essayDraftHistoryReportApiSlice";

export interface EssayDraftHistorySummary {
	writerId?: number;
	writerFormalFullName?: string;
	draftCount: number;
	averageIncrease: number;
	differenceFromClassAverage?: number;
	draftHistory: DraftHistoryViewModel[];
	promptName?: string;
}

export type EssayDraftHistoryTableProps = {
	data?: EssayDraftHistorySummary[];
};

export const teacherFilteredColumns: Record<string, string> = {
	writerFormalFullName: "Writer",
	draftCount: "Number of Drafts",
	averageIncrease: "Average Score Increase per Draft",
	differenceFromClassAverage: "Δ from Class Average (Last Draft)",
};

export const studentFilteredColumns: Record<string, string> = {
	promptName: "Prompt",
	draftCount: "Number of Drafts",
	averageIncrease: "Average Score Increase per Draft",
};
